module.exports = __webpack_public_path__ + "static/media/user3.3fae868f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user3.png
// module id = 64
// module chunks = 0